import { useState } from 'react';

// Displays a credential that exists exactly once.
//
// Shown as text rather than hidden behind a reveal, because it has to be copied
// somewhere immediately -- a masked field invites someone to close the page
// assuming they can come back to it. The copy button uses the clipboard API and
// falls back to selecting the text, since the clipboard is unavailable in some
// browsers over anything the user might have hit this page through.
export function OneTimeSecret({
  label,
  value,
  note,
}: {
  label: string;
  value: string;
  note: string;
}) {
  const [copied, setCopied] = useState(false);

  return (
    <div className="secret">
      <label>
        {label}
        <input
          readOnly
          value={value}
          spellCheck={false}
          onFocus={(event) => event.currentTarget.select()}
        />
      </label>
      <button
        type="button"
        onClick={() => {
          void navigator.clipboard
            ?.writeText(value)
            .then(() => setCopied(true))
            .catch(() => setCopied(false));
        }}
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
      <p className="warn">{note}</p>
    </div>
  );
}
